import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

// État réseau du Raspberry (mode 4G/Wi-Fi, signal, route par défaut, WireGuard)
// via Infra API SSH (LECTURE SEULE). Le mode actif vient de la route par défaut, pas de wg0.
export function useNetworkStatus(droneId, { interval = 10000, enabled = true } = {}) {
  const [net, setNet] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!droneId) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/drones/${droneId}/network`);
      setNet(data);
      setError(data.reachable ? null : (data.reason || data.error || "indisponible"));
    } catch (e) {
      setError(e?.response?.data?.detail || "indisponible");
    } finally {
      setLoading(false);
    }
  }, [droneId]);

  useEffect(() => {
    if (!enabled) return;
    let stopped = false, timer = null;
    const run = async () => { await load(); if (!stopped) timer = setTimeout(run, interval); };
    run();
    return () => { stopped = true; if (timer) clearTimeout(timer); };
  }, [enabled, interval, load]);

  return { net, loading, error, reload: load };
}

// Couleur du statut global de connexion.
export const NET_STATUS_META = {
  online: { color: "#22C55E", label: "En ligne" },
  degraded: { color: "#F59E0B", label: "Dégradé" },
  offline: { color: "#EF4444", label: "Hors ligne" },
  unknown: { color: "#A3A3A3", label: "—" },
};
export const nsm = (s) => NET_STATUS_META[s] || NET_STATUS_META.unknown;

// Couleur d'un signal en % (>=60 vert, 30-59 orange, <30 rouge, null gris).
export function signalColor(pct) {
  if (pct == null) return "#A3A3A3";
  if (pct >= 60) return "#22C55E";
  if (pct >= 30) return "#F59E0B";
  return "#EF4444";
}

// Barres réseau (0..4) à partir d'un %.
export function signalBars(pct) {
  if (pct == null) return 0;
  if (pct >= 75) return 4;
  if (pct >= 50) return 3;
  if (pct >= 30) return 2;
  if (pct > 0) return 1;
  return 0;
}

export function fmtHandshake(s) {
  if (s == null) return "—";
  if (s < 60) return `il y a ${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `il y a ${m}min`;
  return `il y a ${Math.floor(m / 60)}h`;
}
